/**
 * Processes a single document from API (get resource) into a file with id.
 * Shared by pensioners createUpdateConfig and profile useCreateUpdateConfig.
 *
 * A document whose file is gone from GridFS comes back with a null `_id`
 * once populated: it resolves to null, so one missing file does not keep the
 * others from loading. Callers drop the nulls.
 * @function
 *
 * @param {Object} doc - Document from API ({ _id, type }).
 * @param {function} createFileFromJSON - Function(id, dispatchAPI, message) => Promise.
 * @param {function} dispatchAPI - API dispatch.
 * @param {function} message - Error message handler.
 * @returns {Promise<?{ type: string, file: Object }>} - { type, file } for aggregation by caller, null when the file is missing.
 */
export const processOneDocumentForGetResource = async (
  doc,
  createFileFromJSON,
  dispatchAPI,
  message
) => {
  if (!doc?._id) return null;

  const file = await createFileFromJSON(doc._id, dispatchAPI, message);
  if (!file) return null;

  file.file.id = file._id;
  return { type: doc.type, file: file.file };
};
